import styled from "styled-components"

export const MainContent = styled.main`
  max-width: 980px;
  margin: 0 auto;
`
